import React, { useState } from "react";
import { Notification, Collapsible } from 'grommet';

const BannerNotification = () => {

  //const [showNotification, setShowNotification] = useState(true);
  const [showNotification, setShowNotification] = useState(false);

  return (
    <Collapsible open={showNotification}>
      <Notification
        status="normal"
        title="News flash!"
//        status="warning"
//        title="Warning"      
        margin={{ top: '5px' }}
        onClose={() => setShowNotification(false)}
        actions={[
          {
            href: 'https://hpe.com/',
            label: 'More info',
          },
        ]}
        message="Brand new API standards and utilities published."
 //       message="Subscription activation rates below statistical norm. "
        global
      />
    </Collapsible>
   );
};

export { BannerNotification as Notification };